<template>
    <div class="head">
        <img src="@/assets/image/login/head.png" class="top-logo"/>
        <div class="top-right">
            <!-- <div class="top-right-name">欢迎登录！</div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'mianHead',
    data() {
        return {
        }
    },
    methods: {
    },

}
</script>

<style lang="scss" scoped>
.head {
    width: 100%;
    height: 6.4rem;
    background-image: url('@/assets/image/head/top-bg.png');
    background-size: 100% 100%;
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 0.3rem 1rem 0px rgba(17, 72, 153, 0.04);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    // margin-bottom: 10px;
}

.top-logo {
    width: 34.6rem;
    height: 4rem;
    margin-left: 4.4rem;
}

.cursor {
    cursor: pointer;
}

.top-right {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    align-items: center;
}

.top-icon {
    margin-right: 1.2rem;
}

.pointer {
    cursor: pointer;
}

.menu {
    position: relative;

    .menu-content {
        width: 17rem;
        position: absolute;
        top: 4.5rem;
        right: 50%;
        transform: translateX(50%);
        background: #FFFFFF;
        box-shadow: 0px 0.4rem 1.2rem 0px rgba(0, 0, 0, 0.15);
        border-radius: 0.4rem;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem;
        box-sizing: border-box;

        .menu-item {
            width: 15rem;
            height: 3.6rem;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 1.4rem;
            color: #384D6E;
            text-align: center;
            line-height: 3.6rem;
            border-radius: 0.4rem;
            text-align: center;
            cursor: pointer;

            &:hover {
                background: #F0F6FF;
            }
        }
    }

    img:hover {
        box-shadow: 0px 0.3rem 1rem 0px rgba(17, 72, 153, 0.04);
    }
}


.top-right-line {
    width: 0.2rem;
    height: 2rem;
    background: #E4E7ED;
    margin: 0 2.2rem;
}

.top-right-name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 1.6rem;
    color: #303133;
    margin-right: 4.4rem;
}
</style>
